import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const formatDriveImage = (url) => {
  if (!url) return null;

  if (url.includes("drive.google.com")) {
    const match = url.match(/\/d\/([^/]+)/);
    if (match?.[1]) {
      return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w1200`;
    }
  }
  return url;
};

const AcademyDetail = () => {
  window.scrollTo(0, 0);
  const { slug } = useParams();
  const navigate = useNavigate();

  const [academy, setAcademy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://sattva-backend.demetrix.in/academy")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const found = data.data.find(
            (item) =>
              item.slug === slug &&
              item.is_published &&
              !item.is_deleted
          );
          setAcademy(found || null);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin w-10 h-10 border-4 border-gray-300 border-t-black rounded-full"></div>
      </div>
    );
  }

  if (!academy) {
    return <p className="pt-20 text-center">Academy article not found</p>;
  }

  /* IMAGE */
  const imageMedia = academy.media?.find((m) => m.type === "image");
  const imageUrl = formatDriveImage(imageMedia?.url);

  /* VIDEO */
  const videoMedia = academy.media?.find((m) => m.type === "video");
  let videoUrl = null;
  if (videoMedia?.url?.includes("youtube.com")) {
    const id = videoMedia.url.match(/v=([^&]+)/)?.[1];
    if (id) videoUrl = `https://www.youtube.com/embed/${id}`;
  }

  return (
    <div className="min-h-screen pt-20 pb-20 max-w-4xl mx-auto px-6">
      <div className="flex flex-col md:flex-row items-center justify-between mb-6 pt-16 gap-4">
        <h1 className="text-3xl font-bold flex-1">
          {academy.title}
        </h1>

        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 text-sm border rounded-lg hover:bg-gray-100"
        >
          Close
        </button>
      </div>

      <span className="inline-block text-xs mb-4 px-3 py-1 rounded-full 
                       border border-green-600 text-green-700">
        {academy.category}
      </span>


      {academy.description && (
        <p className="text-gray-600 italic mb-6">
          {academy.description}
        </p>
      )}

      <div className="grid md:grid-cols-3 gap-6 mb-10 items-start">

        <div className="md:col-span-2 text-gray-700 whitespace-pre-line leading-relaxed">
          {academy.content}
        </div>

        {imageUrl && (
          <div className="md:col-span-1">
            <img
              src={imageUrl}
              alt={academy.title}
              className="w-full rounded-lg"
              loading="lazy"
            />
          </div>
        )}
      </div>

     
      {videoUrl && (
        <div className="mt-10">
          <iframe
            src={videoUrl}
            className="w-full h-[400px] rounded-lg"
            allowFullScreen
            title="Academy Video"
          />
        </div>
      )}
    </div>
  );
};

export default AcademyDetail;
